
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[articleId]",
      function () {
        return require("private-next-pages/product/[articleId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[articleId]"])
      });
    }
  